<ppb-start-container [width]="'wide'">
    <form [formGroup]="loginForm"
          autocomplete="off">
        <div>
            <div>
                <h3 class="login-title"
                    i18n="@@account.set_password"
                >Ustaw hasło</h3>
                <div class="login-field-cont" *ngIf="!isLinkValid">
                  {{errorText}}
                </div>
                <div *ngIf="!isLinkValid"
                     fxLayout="row"
                     fxLayoutAlign="end stretch">
                  <div>
                    <pseic-async-button
                      [isLoading$]="isLoading$"
                      [type]="ButtonType.SUBMIT"
                      (buttonClicked)="mainPage()"
                      i18n="@@common.go_to_home_page"
                    >Powrót do strony głównej</pseic-async-button>
                  </div>
                </div>
                <div class="login-field-cont" *ngIf="isLinkValid">
                    <div fxLayout="row"
                         fxLayoutAlign="start center"
                         fxLayoutGap="24px">
                        <div fxFlex="50">
                            <div class="o-form-group">
                                <pseic-form-field label="Podaj nowe hasło"
                                                  labelFor="newPassword"
                                                  [resizeOnError]="false"
                                                  i18n-label="@@login.enter_new_password">
                                    <div class="o-form-field-btn-holder">
                                        <input class="o-form-field"
                                           placeholder="Nowe hasło"
                                           id="newPassword"
                                           type="password"
                                               #passwordField
                                           [pseicAutofocus]="true"
                                           autocomplete="new-password"
                                           formControlName="newPassword"
                                           i18n-placeholder="@@login.new_password"
                                        />
                                        <div class="o-form-field-btn-holder__btn"
                                           (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'">
                                           <psei-icon class="o-form-field-btn-holder__icon"
                                                   name="view"
                                                   [size]="'L'">
                                            </psei-icon>
                                        </div>
                                    </div>
                                </pseic-form-field>
                            </div>
                        </div>
                        <div fxFlex="50">
                            <div class="hints">
                                <div i18n="@@login.min_length_password">Hasło musi składać się z min. 9 znaków.</div>
                                <div i18n="@@login.min_strength_password">Minimalna siła hasła 3.</div>
                            </div>
                        </div>
                    </div>
                    <div fxLayout="row"
                         fxLayoutAlign="start center"
                         fxLayoutGap="24px">
                        <div fxFlex="50">
                            <div class="o-form-group">
                                <pseic-form-field label="Powtórz hasło"
                                                  labelFor="newPasswordConfirm"
                                                  [resizeOnError]="false"
                                                  i18n-label="@@login.repeat_password">
                                  <div class="o-form-field-btn-holder">
                                      <input class="o-form-field"
                                               #passwordConfirmField
                                               placeholder="Nowe hasło"
                                               id="newPasswordConfirm"
                                               type="password"
                                               autocomplete="new-password"
                                               formControlName="newPasswordConfirm"
                                               i18n-placeholder="@@login.new_password"
                                      />
                                      <div class="o-form-field-btn-holder__btn"
                                           (click)="passwordConfirmField.type === 'password' ? passwordConfirmField.type = 'text' : passwordConfirmField.type = 'password'">
                                          <psei-icon class="o-form-field-btn-holder__icon"
                                                   name="view"
                                                   [size]="'L'">
                                          </psei-icon>
                                      </div>
                                  </div>
                                </pseic-form-field>
                            </div>
                        </div>
                        <div fxFlex="50">
                            <div class="hints">
                                <div i18n="@@login.passwords_equals_dot">Hasła muszą być takie same.</div>
                            </div>
                        </div>
                    </div>
                    <div>&nbsp;</div>
                    <div fxLayout="row"
                         fxLayoutAlign="start center"
                         fxLayoutGap="24px">
                        <div fxFlex="50">
                            <div class="o-form-label"
                                 i18n="@@login.passwords_strength"
                            >Siła hasła {{passwordStrength || 0}}/4</div>
                            <div class="password-strength-container">
                                <div class="password-strength-line"
                                     [attr.data-strength]="passwordStrength"></div>
                            </div>
                        </div>
                        <div fxFlex="50"></div>
                    </div>
                    <div *ngIf="step === 2"
                         class="auth-code-container">
                        <div fxLayout="row"
                             fxLayoutAlign="start center"
                             fxLayoutGap="24px">
                            <div i18n="@@common.enter_sms_code_colon">Podaj kod SMS:</div>
                            <div>
                                <pseic-form-field [resizeOnError]="false">
                                    <input class="o-form-field auth-code"
                                           placeholder="Kod SMS"
                                           id="smsCode"
                                           pseicAutofocus
                                           type="number"
                                           formControlName="smsCode"
                                           i18n-placeholder="@@common.sms_code"
                                    >
                                </pseic-form-field>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="step === 1"
                         fxLayout="row"
                         fxLayoutAlign="end center"
                         fxLayoutGap="24px"
                    >
                        <div>
                            <button class="o-btn o-btn--secondary o-btn--small"
                                    type="button"
                                    routerLink="/"
                                    i18n="@@common.cancel"
                            >Anuluj</button>
                        </div>
                        <div>
                          <pseic-async-button
                            [isLoading$]="isLoading$"
                            [type]="ButtonType.SUBMIT"
                            (buttonClicked)="nextStep(2)"
                            i18n="@@common.next"
                          >Dalej</pseic-async-button>
                        </div>
                    </div>
                    <div *ngIf="step === 2"
                         fxLayout="row"
                         fxLayoutAlign="end center"
                         fxLayoutGap="24px"
                    >
                      <button class="o-btn o-btn--secondary o-btn--small"
                              type="button"
                              routerLink="/"
                              i18n="@@common.cancel">Anuluj</button>
                        <div>
                          <pseic-async-button
                            [isLoading$]="isLoading$"
                            [type]="ButtonType.SUBMIT"
                            (buttonClicked)="nextStep(3)"
                            i18n="@@common.next"
                          >Dalej</pseic-async-button>
                        </div>
                    </div>
                    <div *ngIf="!isLinkValid"
                         fxLayout="row"
                         fxLayoutAlign="end stretch">
                        <div>
                          <pseic-async-button
                            [isLoading$]="isLoading$"
                            [type]="ButtonType.SUBMIT"
                            (buttonClicked)="nextStep(3)"
                            i18n="@@common.go_to_home_page"
                          >Powrót do strony głównej</pseic-async-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ppb-start-container>
